export default function getDecodedId(id) {
  if (!id) {
    return;
  }
  return atob(id).split(':').pop();
}
